export enum Provider {
  ANONYMOUS = 'anonymous',
  LOCAL = 'local',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}
